import { Mail, Clock, MapPin, Phone, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/anim";
import Starfield from "../components/Starfield";

export default function Contact() {
  return (
    <main className="relative min-h-screen overflow-hidden pt-28 pb-20" data-testid="contact-page">
      <Starfield />
      <div className="pointer-events-none absolute -top-32 right-[-10%] h-[420px] w-[420px] rounded-full bg-violet-600/15 blur-[130px]" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <Reveal>
          <Eyebrow>Contact</Eyebrow>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-white sm:text-6xl">
            Let's talk about your website.
          </h1>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-slate-400">
            Call, text or email us — a real person replies within one business day.
          </p>
          <div className="mt-10 space-y-5">
            {[
              { icon: Phone, label: "Call or text", value: "(507) 841-1801", href: "tel:+15078411801" },
              { icon: Mail, label: "Email", value: "bengall.work3@gmail.com", href: "mailto:bengall.work3@gmail.com" },
              { icon: Clock, label: "Response time", value: "Within 1 business day" },
              { icon: MapPin, label: "Based in", value: "Remote-first, serving clients everywhere" },
            ].map(({ icon: Icon, label, value, href }) => (
              <div key={label} className="flex items-center gap-4" data-testid={`contact-info-${label.toLowerCase().replace(/\s/g, "-")}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-500/10">
                  <Icon className="h-5 w-5 text-blue-400" />
                </span>
                <div>
                  <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">{label}</p>
                  {href ? (
                    <a href={href} className="text-sm font-semibold text-blue-400 hover:text-blue-300" data-testid={`contact-link-${label.toLowerCase().replace(/\s/g, "-")}`}>{value}</a>
                  ) : (
                    <p className="text-sm font-semibold text-white">{value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="rounded-3xl border border-white/10 bg-[#0B1026] p-8 text-white sm:p-10" data-testid="contact-call-card">
            <p className="font-mono2 text-xs font-semibold uppercase tracking-[0.2em] text-blue-400">Book a Free Call</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl">Call (507) 841-1801</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">
              Tell us about your business and what you need your website to do. We'll talk it through and take it
              from there — no pressure, no obligation.
            </p>
            <ul className="mt-6 space-y-2.5">
              {["Free intro call", "Reply within one business day", "Hosting handled for you"].map((t) => (
                <li key={t} className="flex items-center gap-2.5 text-sm text-slate-300">
                  <Check className="h-4 w-4 text-emerald-400" /> {t}
                </li>
              ))}
            </ul>
            <a
              href="tel:+15078411801"
              data-testid="contact-call-btn"
              className="group mt-8 flex items-center justify-center gap-2 rounded-full bg-blue-600 py-4 text-sm font-semibold text-white transition-colors hover:bg-blue-500/100"
            >
              <Phone className="h-4 w-4" />
              Call Now
            </a>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
